module.exports = __webpack_public_path__ + "img/seminLogo.1d8d5fca.png";